import { scrollToFootnote } from '~/components/footnotes/footnote-renderer';

export function FootnoteReferenceNgc({ reference }: { reference: string | number }) {
	return (
		<button onClick={() => scrollToFootnote(reference)}>
			<sup>{Number(reference) ? String.fromCharCode(Number(reference) + 'a'.charCodeAt(0)) : reference}</sup>
		</button>
	);
}
